/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { SearchSnowstormConcept } from './SearchSnowstormConcept'; 

export function getConceptOptions(conceptId: string, onSuccess?: (result: SearchSnowstormConcept) => void) {
	return queryOptions({
		queryKey: ['concept', conceptId],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/libraries/concepts/queries/getconcept/' + conceptId;
			const resp = await axios.get<SearchSnowstormConcept>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: Boolean(conceptId)
	});
}